import { createFileRoute } from "@tanstack/react-router";
import { AgendaEditarPage } from "@/paginas/pg_agenda/agenda-editar";

export const Route = createFileRoute("/_authenticated/agenda-editar")({
  head: () => ({
    meta: [
      { title: "Agenda — Editar — Milky Moo Palmares" },
      { name: "description", content: "Editar evento na agenda." },
    ],
  }),
  component: AgendaEditarPage,
});
